module.exports = __webpack_public_path__ + "img/Zegeba_Color_Poweredby.d1335ee0.png";